import React from 'react';
import { Link } from '@tanstack/react-router';
import ITag from '../ITag';

/**
 * CardGrid - A reusable component for displaying a grid of cards with optional load more
 *
 * @param {Object} props
 * @param {Array} props.data - Array of data items to render (required)
 * @param {Function} props.renderCard - Function that renders a card given an item (required)
 * @param {boolean|React.ReactNode} props.showLoadMore - Whether to show load more button, or custom element
 * @param {Function} props.onLoadMore - Callback when load more is clicked (optional)
 * @param {string} props.loadMoreTo - Router link destination for load more (default: "/")
 * @param {string} props.className - Additional CSS classes for the card-grid container
 */
function CardGrid({
  data = [],
  renderCard,
  showLoadMore = true,
  onLoadMore,
  loadMoreTo = "/",
  className = ""
}) {
  if (!Array.isArray(data)) {
    console.warn('CardGrid: data prop must be an array', data);
    return null;
  }

  if (typeof renderCard !== 'function') {
    console.warn('CardGrid: renderCard prop must be a function');
    return null;
  }

  return (
    <div className={`card-body ${className}`}>
      <div className="row">
        {data.map((item, index) => (
          <React.Fragment key={item?.id || index}>
            {renderCard(item, index)}
          </React.Fragment>
        ))}

        {showLoadMore && (
          <div className="col-md-12 text-center mt-3">
            {typeof showLoadMore === 'function' ? (
              showLoadMore()
            ) : onLoadMore ? (
              <button
                onClick={onLoadMore}
                className="btn bg-gradient-dark mb-0"
              >
                <ITag ClassName="fas fa-plus mr-10" />
                Load More
              </button>
            ) : (
              <Link className="btn bg-gradient-dark mb-0" to={loadMoreTo}>
                <ITag ClassName="fas fa-plus mr-10" />
                Load More
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default CardGrid;
